/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as userService from '../services/userService'
class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      oldpasscode: "",
      passcode: "",
      repasscode: "",
      passVisible: false,
      oldpassVisible: false,
      repassVisible: false,
      toastMsg: "",
      toastType: ""
    };
  }
  showToast(msg, type) {
    let self = this
    this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
      setTimeout(() => {
        self.setState({ toastMsg: "", toastType: "", showToast: false })
      }, 3000);
    })
  }
  componentDidMount() {
    let userData = localStorage.getItem("tokenData")
    userData = JSON.parse(userData)
    if(!!userData && !!userData.sub){
      this.setState({ uid: userData.sub })
    }
    else {
         // if (!userData || !userData.sub) {
      localStorage.clear();
      this.props.history.push("/auth")
    }
  }
  async submitForm() {
    if (!this.state.oldpasscode) {
      this.props.notify("Please insert old password!", "error");
      return false
    }
    if (!this.state.passcode) {
      this.props.notify("Please insert new password!", "error");
      return false
    }
    if (this.state.passcode.length < 6) {
      this.props.notify("Password must have atleast 6 digit!", "error");
      return false
    }
    if (this.state.passcode !== "" && this.state.passcode !== this.state.repasscode) {
      return false
    }
    if (this.state.passcode !== "" && this.state.passcode === this.state.oldpasscode) {
      return false
    }
    let body = {
      "password": this.state.oldpasscode,	
      "newPassword": this.state.passcode,	
      "userName": this.state.uid
    }
    await userService.changePassword(body).then((res) => {
      if (res.isSuccess) {
        this.props.notify("Password changed successfully!", "success")
        this.props.history.push('/dashboard')
        // this.props.notify("Password changed successfully!", "success")
      } else {
        this.props.notify(res.exception.message, "error")
      }
    })
  }
  handleKey(e) {
    if (e.keyCode === 13) {
      if (this.state.passcode.match(/[0-9]/g) && this.state.passcode.match(/[a-zA-Z]/g) && this.state.passcode.length >= 8 && this.state.passcode !== this.state.oldpasscode && this.state.passcode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 && this.state.passcode === this.state.repasscode) {
        this.submitForm();
      } else {
        this.props.notify("Invalid", "error")
      }
    }
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {

      if (name === "passcode" && !!value) {
        if (value.match(/[0-9]/g)) {
          document.getElementById("digit").className = "success-text"
        } else {
          document.getElementById("digit").className = ""
        }

        if (value.match(/[a-zA-Z]/g)) {
          document.getElementById("scharacter").className = "success-text"
        } else {
          document.getElementById("scharacter").className = ""
        }

        if (value.length >= 8) {
          document.getElementById("minlength").className = "success-text"
        } else {
          document.getElementById("minlength").className = ""
        }

        if (value === this.state.oldpasscode) {
          document.getElementById("notold").className = "error-text d-block"
        } else {
          document.getElementById("notold").className = "error-text d-none"
        }

        if (value.toLowerCase().indexOf(this.state.uid.toLowerCase()) !== -1) {
          document.getElementById("notuser").className = "error-text d-block"
        } else {
          document.getElementById("notuser").className = "error-text d-none"
        }
      }
    })
  }

  onPasswodVisible(passid, name, value) {
    if (!!value) {
      document.getElementById(passid).type = "Password"
    } else {
      document.getElementById(passid).type = "text"
    }
    this.setState({ [name]: !value })
  }

  render() {
    return (
      <body className="bethubs">
        <Header history = {this.props.history} />
        <div className="wrapper">
          <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
            <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
            <ul>
              <li><a href="list-of-clients.html">List of Clients</a></li>
              <li><a href="#">Market Analysis</a></li>
              <li><a href="import-event.html">Import Event</a></li>
              <li>
                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                <ul className="list-unstyled collapse" id="homeSubmenu" >
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
              <li>
                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                <ul className="list-unstyled collapse" id="home1Submenu" >
                  <li><a href="#">Test 1</a></li>
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="container-fluid container-padding-0">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="main-box">
                  <h5 className="text-blue">Change Password</h5>
                  <div className="row supermaster mt-3">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                      <div className="form-group col-12">
                        <label for="name">Old Password:</label>
                        <input type="Password" value={this.state.oldpasscode} name="oldpasscode" id="oldpasscode" onChange={(e) => { this.onChange(e) }} className="form-control" placeholder="" />
                        <span onClick={() => { this.onPasswodVisible("oldpasscode", "oldpassVisible", this.state.oldpassVisible) }} className="changePasscode-visible">{!!this.state.oldpassVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                      </div>
                      <div className="form-group col-12 change-password-valid">
                        <label for="name">New Password:</label>
                        <input type="Password" value={this.state.passcode} name="passcode" id="passcode" onChange={(e) => { this.onChange(e) }} className="form-control" placeholder="" />
                        <span onClick={() => { this.onPasswodVisible("passcode", "passVisible", this.state.passVisible) }} className="changePasscode-visible">{!!this.state.passVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                        {/* {this.state.passcode !== "" && this.state.passcode === this.state.oldpasscode ? <label style={{ color: "red" }}>Old Password and New Password should not be changed.</label> : null} */}
                        {!!this.state.passcode && <>
                          <ul>
                            <li id="digit" className=""><i className="fa fa-check"></i> At least 1 digit</li>
                            <li id="scharacter" className=""><i className="fa fa-check"></i> At least 1 character</li>
                            <li id="minlength" className=""><i className="fa fa-check"></i> Minimum 8 characters</li>
                          </ul>
                          <ul>
                            <li id="notold" className="error-text d-none"><i className="fa fa-close"></i> Password not same as old</li>
                            <li id="notuser" className="error-text d-none"><i className="fa fa-close"></i> Password Not contain Username</li>
                          </ul>
                        </>}
                      </div>
                      <div className="form-group col-12">
                        <label for="name">Retype Password:</label>
                        <input type="Password" value={this.state.repasscode} onKeyUp={(e) => { this.handleKey(e) }} name="repasscode" id="repasscode" onChange={(e) => { this.onChange(e) }} className="form-control" placeholder="" />
                        <span onClick={() => { this.onPasswodVisible("repasscode", "repassVisible", this.state.repassVisible) }} className="changePasscode-visible">{!!this.state.repassVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                        {this.state.passcode !== "" && this.state.passcode !== this.state.repasscode ? <label style={{ color: "red" }}>This field should be same as password.</label> : null}
                      </div>
                      <div className="col-12 mt-4">
                        <div className="text-right">
                          <button className="btn btn-blue accbtn mt-0" onClick={() => { this.submitForm() }} disabled={this.state.passcode.match(/[0-9]/g) && this.state.passcode.match(/[a-zA-Z]/g) && this.state.passcode.length >= 8 && this.state.passcode !== this.state.oldpasscode && this.state.passcode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 && this.state.passcode === this.state.repasscode ? false : true}>Change Password</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </body>
    )
  }
}
function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);